import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';

import menuItemsData from '../../../services/menu-items-data';
import './header.css';

const regularMenuItemStyle = {
  fontWeight: 'bold',
  letterSpacing: '3px',
  color: 'white'
};

const miniMenuStyles = {
  margin: '10px',
  '& svg': {
    height: '35px',
    width: '35px',
  },
};

class Header extends Component {
  state = {
    isMiniMenuOpen: false,
  };

  onMiniMenuToggle = () => {
    this.setState(prev => ({
      isMiniMenuOpen: !prev.isMiniMenuOpen,
    }));
  };

  onMiniMenuRequestChange = () => {
    this.setState({ isMiniMenuOpen: false });
  };

  render() {
    return (
      <header className="main-header">
        <nav>
          {menuItemsData.map(itemData => (
            <Link to={itemData.link} key={itemData.text}>
              <div>{itemData.text}</div>
            </Link>
          ))}
        </nav>

        <div className="mini-menu-container">
          <IconButton
            onClick={this.onMiniMenuToggle}
            sx={miniMenuStyles}
          >
            <MenuIcon />
          </IconButton>

          <Drawer
            anchor="left"
            open={this.state.isMiniMenuOpen}
            onClose={this.onMiniMenuRequestChange}
            PaperProps={{
              sx: {
                backgroundColor: 'rgba(14, 41, 64, 0.92)',
                color: '#fff',
              },
            }}
          >
            <Box sx={{ width: 250 }} >
              {menuItemsData.map(itemData => (
                <MenuItem
                  key={itemData.text}
                  component={Link}
                  to={itemData.link}
                  onClick={this.onMiniMenuToggle}
                  sx={{
                    fontWeight: 'bold',
                    letterSpacing: '3px',
                    color: 'whitesmoke',

                    '&:link, &:visited': {
                      color: 'whitesmoke',
                    },
                    '&:hover': {
                      color: 'whitesmoke',
                      backgroundColor: 'rgba(255,255,255,0.08)',
                    },
                  }}
                >
                  {itemData.text}
                </MenuItem>
              ))}
            </Box>
          </Drawer>
        </div>
      </header>
    );
  }
}

export default Header;
